//data and formatting imports
import { selectData } from 'layouts/onboarding'
import dashboardData from 'layouts/authenticated/pages/dashboard/data/dashboardData'
import { format } from 'date-fns'
import { useNavigate } from 'react-router-dom'

import Card from 'atoms/Card'
import Banner from 'atoms/Banner'

// One-Off Components
import WizardStep from 'components/WizardSteps/WizardStep'
//ready
// import RetirementGoals from 'components/RetirementGoals'
//not ready
import HealthcareTileSelector from 'components/HealthcareTileSelector'
import PlannedRetirementTileSelector from 'components/PlannedRetirementTileSelector'
import CompletedOnboarding from 'components/CompletedOnboarding'
import OnboardingFirstLastPhoneDOB from 'components/OnboardingFirstLastPhoneDOB'
import OnboardingSpouse from 'components/OnboardingSpouse'
import OnboardingPaystub from 'components/OnboardingPaystub'
import AgencyTileSelector from 'components/AgencyTileSelector'
import RetirementSystemTileSelector from 'components/RetirementSystemTileSelector'
import OnboardingLeave from 'components/OnboardingLeave'
import OnboardingTSP from 'components/OnboardingTSP'
import OnboardingMilitaryReserves from 'components/OnboardingMilitaryReserves'
import OnboardingMilitaryBranch from 'components/OnboardingMilitaryBranch'
import OnboardingMilitaryServiceDates from 'components/OnboardingMilitaryServiceDates'
import OnboardingMaritalStatus from 'components/OnboardingMaritalStatus'
import OnboardingDivorceDates from 'components/OnboardingDivorceDates'
import OnboardingTSPRoth from 'components/OnboardingTSPRoth'
import OnboardingSchedule from 'components/OnboardingSchedule'
import Onboarding401k from 'components/Onboarding401k'
import Onboarding401kDetails from 'components/Onboarding401kDetails'
import ServiceCompDate from 'components/ServiceCompDate'
import { PaycheckOCR } from 'components/PaycheckOCR'

// Reusable Components
import OnboardingMultiSelectTile from 'components/OnboardingMultiSelectTile'
import OnboardingMultiOptionTile from 'components/OnboardingMultiOptionTile'
import OnboardingMultiQuestion from 'components/OnboardingMultiQuestion'
import OnboardingYesNo from 'components/OnboardingYesNo'
import OnboardingInformation from 'components/OnboardingInformation'
// add yes/no multifield combo

// mui components
import { Link } from '@mui/material'

// mui icons
import WorkIcon from '@mui/icons-material/Work'
import BeachAccessIcon from '@mui/icons-material/BeachAccess'
import OnboardingLifeInsurance from 'components/OnboardingLifeInsurance'
import OnboardingFamilyDependents from 'components/OnboardingFamilyDependents'
import NetWorthGraph from 'layouts/authenticated/pages/newdash/components/NetWorthGraph'
import NetWorthTable from 'layouts/authenticated/pages/newdash/components/NetWorthTable'
import AssetReview from '../components/netWorthFlow/AssetReview'
import LiabilityReview from '../components/netWorthFlow/LiabilitiyReview'
import NetWorthUnlock from '../components/netWorthFlow/NetWorthUnlock'
import TSPUnlock from '../components/tspFlow/TSPUnlock'
import NewTsp from 'layouts/authenticated/pages/tsp/NewTsp'
import RetirementGapTable from 'layouts/authenticated/pages/newdash/components/RetirementGapTable'
import RetirementGapUnlock from '../components/RetirementGapUnlock'
import LifeInsuranceSummary from 'layouts/authenticated/pages/fegli/components/LifeInsuranceSummary'
import TSPLoan from '../components/tspLoan/TSPLoan'
import { LifestyleGoal } from 'components/LifestyleGoal'
//other imports
// import scorePlaceholder from 'assets/images/scorePlaceholder.png'

//dollar formatting for help text
// const dollarFormat = Intl.NumberFormat('en-US', {
//   style: 'currency',
//   currency: 'USD',
// })

// const navigate = useNavigate()

export const steps = [
  {
    id: 'onboardingBasics',
    component: OnboardingFirstLastPhoneDOB,
    type: 'Question',
    tags: [],
    props: {
      handleNextOverride: async (intakeState, onboardingHooks) => {
        const { updateIntakeStateAtKey } = onboardingHooks
        updateIntakeStateAtKey({
          firstName: `${intakeState?.firstName.trim()}`,
          fullName: `${intakeState?.firstName.trim()} ${intakeState?.lastName}`,
          pickYourPath: 1,
        })
        return {
          intakeState: {
            ...intakeState,
            firstName: `${intakeState?.firstName.trim()}`,
            fullName: `${intakeState?.firstName.trim()} ${
              intakeState?.lastName
            }`,
            pickYourPath: 1,
          },
        }
      },
    },
  },
  {
    id: 'governmentEmployeeSelector',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['onboarding'],
    props: {
      header: 'Do you work for or are you retired from the federal government?',
      subHeader: 'Select one of the following:',
      id: 'governmentEmployee',
      handleNextOverride: async (intakeState, onboardingHooks) => {
        const { updateIntakeStateAtKey } = onboardingHooks
        updateIntakeStateAtKey({
          governmentEmployee: intakeState.governmentEmployee,
        })
        return {
          intakeState: {
            ...intakeState,
            governmentEmployee: intakeState.governmentEmployee,
          },
        }
      },
    },
    dependencies: [],
  },
  {
    id: 'employmentStatus',
    type: 'Question',
    component: OnboardingMultiOptionTile,
    tags: ['employmentDetails', 'onboarding'],
    props: {
      id: 'employmentStatus',
      preHeader: '',
      header: 'What is your employment status?',
      subHeader: 'Select one of the following:',
      helpText: '',
      expectedDataType: 'string',
      tileSize: { xs: 6 },
      optionArray: [
        {
          optionLabel: 'Employed',
          optionValue: 'employed',
          optionIcon: <WorkIcon />,
        },
        {
          optionLabel: 'Retired',
          optionValue: 'retired',
          optionIcon: <BeachAccessIcon />,
        },
      ],
    },
    dependencies: [],
  },
  {
    id: 'employerName',
    type: 'Question',
    component: OnboardingMultiQuestion,
    tags: ['employmentDetails', 'onboarding'],
    props: {
      preHeader: ' ',
      header: 'Who is/was your employer?',
      subHeader: 'Employer / Company Name',
      questionArray: [
        {
          id: 'employerName',
          label: 'Employer Name',
          helpText: 'Your employer / company name',
          enableHelpText: false, // https://linear.app/parco-app/issue/PAR-1773/who-is-was-your-employer-page-changes#comment-90286186
          placeholder: 'Employer Name',
          required: false,
          inputType: 'text',
        },
        {
          id: 'dateOfHire',
          label: 'What is your Date of Hire?',
          placeholder: '01/01/1970',
          required: false,
          inputType: 'splitdate',
          defaultDate: '1990-01-01',
        },
        {
          id: 'hiddenField',
          label: 'Hidden Field',
          helpText: '',
          placeholder: 'Hidden Field',
          required: false,
          inputType: 'text',
          hiddenField: true,
        },
      ],
      handleNextOverride: async (intakeState, onboardingHooks) => {
        const { updateIntakeStateAtKey } = onboardingHooks
        updateIntakeStateAtKey({
          dateOfHire: '1990-01-01',
        })
        return {
          intakeState: {
            ...intakeState,
            dateOfHire: '1990-01-01',
          },
        }
      },
    },
    dependencies: [{ attribute: 'governmentEmployee', value: false }],
  },
  // Retirement Age Slider unlocked! - https://www.figma.com/design/jbrr3B2HBHVga9Y2sgXGK7/%F0%9F%90%A3-Onboarding?node-id=611-401808&m=dev
  //RETIREMENT GAP UNLOCK INTRO
  {
    id: 'RetirementGapIntro',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `Completing onboarding unlocks your Retirement Income Statement and Gap, which are critical to understanding the lifestyle you’re setting yourself up for in retirement.`,
      label: 'Net Worth',
      options: null,
      image: false,
      extraContent: (
        <>
          <RetirementGapTable isDemo={true} />
        </>
      ),
      header: `Let’s calculate the lifestyle you’ll be able to afford in Retirement!`,
      time: '4 Mins on average',
    },
    dependencies: [{ attribute: 'employmentStatus', value: 'employed' }],
  },
  {
    id: 'agencyTileSelector',
    type: 'Question',
    component: AgencyTileSelector,
    tags: ['employmentDetails', 'onboarding'],
    props: { label: 'Which agency do you work for?' },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  {
    id: 'agencyTileSelector',
    type: 'Question',
    component: AgencyTileSelector,
    tags: ['employmentDetails', 'onboarding'],
    props: { label: 'Which agency did you work for?' },
    // additionalContext: {
    //   header: 'Why this matters:',
    //   content: (
    //     <>
    //       <Typography variant="body2">
    //         Certain agencies have specific nuances to retirement rules.
    //         The agency you work for will change our calculations and
    //         recommendations for you.
    //       </Typography>
    //     </>
    //   ),
    // },
    dependencies: [
      { attribute: 'employmentStatus', value: 'retired' },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  {
    id: 'essentialDates',
    type: 'Question',
    component: OnboardingMultiQuestion,
    tags: ['incomeStatement', 'fegli'],
    props: {
      preHeader: '',
      header: 'Tell us your essential Dates:',
      helpText: 'These dates allow us to calculate your retirement situation',
      subHeader: ' ',
      questionArray: [
        {
          id: 'dateOfBirth',
          label: 'What is your Date of Birth?',
          helpText: '',
          placeholder: '01/01/1970',
          required: false,
          inputType: 'splitdate',
          defaultDate: '1970-01-01',
        },
        {
          id: 'dateOfHire',
          label: 'What is your Service Computation Date?',
          helpText:
            "Your official date of hire with the government, including any bought back military time. If you don't know, put your best guess or check your latest SF-50",
          placeholder: '01/01/1970',
          required: false,
          inputType: 'splitdate',
          defaultDate: '1990-01-01',
        },
      ],
      handleNextOverride: async (intakeState, onboardingHooks) => {
        const { updateIntakeStateAtKey } = onboardingHooks
        updateIntakeStateAtKey({
          dateOfBirth: '1970-01-01',
          dateOfHire: '1990-01-01',
        })
        return {
          intakeState: {
            ...intakeState,
            dateOfBirth: '1970-01-01',
            dateOfHire: '1990-01-01',
          },
        }
      },
    },
    dependencies: [
      { attribute: 'dateOfHire', value: undefined },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  {
    id: 'retirementSystemTileSelector',
    type: 'Question',
    component: RetirementSystemTileSelector,
    tags: ['employmentDetails', 'onboarding', 'buyoutFlow'],
    props: {},
    dependencies: [{ attribute: 'governmentEmployee', value: true }],
  },
  {
    id: 'dateOfHire',
    type: 'Question',
    component: ServiceCompDate,
    tags: ['employmentDetails', 'onboarding', 'buyoutFlow'],
    props: {
      preHeader: '',
      header: 'When did you start working for the government?',
      subHeader: `If you're not sure you can estimate your start year instead.`,
      helpText: '',
      questionArray: [
        {
          id: 'dateOfHire',
          label: 'Service Computation Date',
          helpText:
            "Your official date of hire with the government, including any bought back military time. If you don't know, put your best guess or check your latest SF-50",
          placeholder: '01/01/1970',
          required: false,
          inputType: 'splitdate',
          defaultDate: '1990-01-01',
        },
      ],
    },
    dependencies: [{ attribute: 'governmentEmployee', value: true }],
  },
  {
    id: 'interstitialPickYourPath',
    type: 'Question',
    component: OnboardingMultiOptionTile,
    tags: ['onboarding'],
    props: {
      id: 'pickYourPath',
      preHeader: ' ',
      header: `How would you like to continue?`,
      subHeader: ` `,
      helpText: '',
      expectedDataType: 'string',
      tileSize: { xs: '12' },
      optionArray: [
        {
          className: 'textWithDescription',
          optionLabel: 'Head to the Dashboard',
          optionDescription: `Ready to skip to the good stuff? We get it. Just note that some features won't work until you share a bit more info.`,
          optionTimer: '',
          optionTimerClass: '',
          optionValue: 'dashboard',
          optionLink: '/dashboard',
          arrowIndicator: true,
        },
        {
          className: 'textWithDescription',
          optionLabel: `Finish Onboarding`,
          optionLabelBadge: 'Recommended',
          optionDescription: `Complete your details so we can give you the full picture — and the most tailored recommendations possible.`,
          optionTimer: 'Takes an average of 8 min to complete',
          optionTimerClass: '',
          optionValue: 'continueOnboarding',
          arrowIndicator: true,
        },
      ],
    },
    dependencies: [{ attribute: 'hyperOnboarding', value: true }],
  },
  {
    //change to pickYourPath for the redirection
    id: 'pickYourPath',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `To complete your profile and get the analytics and recommendations you need, continue with onboarding.`,
      label: 'Onboarding',
      options: null,
      header: `Your PARCO account has been created!`,
      handleNextOverride: async (intakeState, onboardingHooks) => {
        const { updateIntakeStateAtKey } = onboardingHooks
        updateIntakeStateAtKey({
          pickYourPath: 1,
        })
        return {
          intakeState: {
            ...intakeState,
            pickYourPath: 1,
          },
        }
      },
    },
    dependencies: [{ attribute: 'hyperOnboarding', value: true }],
  },
  {
    id: 'agencyTileSelectorHyper',
    type: 'Question',
    component: AgencyTileSelector,
    tags: [],
    props: { label: 'Which agency do you work for?' },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'governmentEmployee', value: true },
      { attribute: 'hyperOnboarding', value: true },
    ],
  },
  {
    id: 'essentialDatesHyper',
    type: 'Question',
    component: OnboardingMultiQuestion,
    tags: [],
    props: {
      preHeader: '',
      header: 'Tell us your essential Dates:',
      helpText: 'These dates allow us to calculate your retirement situation',
      subHeader: ' ',
      questionArray: [
        {
          id: 'dateOfBirth',
          label: 'What is your Date of Birth?',
          helpText: '',
          placeholder: '01/01/1975',
          required: false,
          inputType: 'date',
        },
        {
          id: 'dateOfHire',
          label: 'What is your Service Computation Date?',
          helpText:
            "Your official date of hire with the government, including any bought back military time. If you don't know, put your best guess or check your latest SF-50",
          placeholder: '01/01/2005',
          required: false,
          inputType: 'date',
        },
      ],
    },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'governmentEmployee', value: true },
      { attribute: 'hyperOnboarding', value: true },
    ],
  },
  {
    id: 'pickYourRetirementType',
    type: 'Question',
    component: OnboardingMultiOptionTile,
    props: {
      id: 'retirementType',
      preHeader: '',
      header: 'What were you planning on doing for retirement?',
      subHeader: `Select one of the following:`,
      helpText: '',
      expectedDataType: 'string',
      tileSize: { xs: '12' },
      optionArray: [
        {
          className: 'textWithDescription',
          optionLabel: 'I plan on taking the VERA',
          optionDescription: `This will allow you to retire with no reduction in benefits, earlier than normal.`,
          optionTimer: 'Before 9/30/2025',
          optionValue: 'vera',
        },
        {
          className: 'textWithDescription',
          optionLabel: `I planned on retiring on a different date`,
          optionDescription: `You will select a retirement date in the future when a VERA is not enforced.`,
          optionValue: 'full',
        },
        // {
        //   className: 'textWithDescription',
        //   optionLabel: 'Explore Deferred Retirement',
        //   optionLabelBadge: 'Urgent',
        //   optionLabelBadgeType: 'error',
        //   optionDescription: `Explore your options regarding your 'Deferred Retirement' offer. We will give you the info you need and provide our PARCO recommendation based on your exact situation.`,
        //   optionTimer: `2 min + time for any additional flows you'd like`,
        //   optionValue: 3,
        // },
        // {
        //   className: 'textWithDescription',
        //   optionLabel: 'Schedule Appointment',
        //   optionLabelBadge: 'Seminar Participants',
        //   optionDescription: `For those who just need to schedule an appointment.`,
        //   optionTimer: '1 min',
        //   optionValue: 3,
        // },
      ],
    },
    dependencies: [{ attribute: 'pickYourPath', value: 3 }],
  },
  {
    id: 'veraDateOfPlannedRetirement',
    type: 'Question',
    component: OnboardingMultiOptionTile,
    tags: ['fegli', 'onboarding'],
    props: {
      id: 'dateOfPlannedRetirement',
      preHeader: '',
      header: 'Which month would you like to retire?',
      subHeader: 'Select one of the following:',
      helpText: '',
      expectedDataType: 'string',
      tileSize: { xs: '4', md: '2', lg: '4', xxl: '2' },
      optionArray: [
        {
          optionLabel: 'April',
          optionValue: '2025-04-30',
        },
        {
          optionLabel: 'May',
          optionValue: '2025-05-31',
        },
        {
          optionLabel: 'June',
          optionValue: '2025-06-30',
        },
        {
          optionLabel: 'July',
          optionValue: '2025-07-31',
        },
        {
          optionLabel: 'August',
          optionValue: '2025-08-31',
        },
        {
          optionLabel: 'September',
          optionValue: '2025-09-30',
        },
      ],
    },
    dependencies: [{ attribute: 'pickYourPath', value: 3 }],
  },
  // {
  //   id: 'interstitialProfile',
  //   type: 'Interstitial Screen',
  //   props: {
  //     inputType: 'displayOnly',
  //     subHeader: `Continue with onboarding to complete your profile.`,
  //     label: 'Profile',
  //     options: null,
  //     header: `Your PARCO account has been created!`,
  //   },
  //   dependencies: [],
  // },
  // PICK YOUR PATH NOW ASSUMED TO BE FULL
  // {
  //   id: 'pickYourPath',
  //   type: 'Question',
  //   component: OnboardingMultiOptionTile,
  //   props: {
  //     id: 'pickYourPath',
  //     preHeader: '',
  //     header: 'Pick Your Path Test',
  //     subHeader: `We've designed two paths into our retirement planner:`,
  //     helpText: '',
  //     expectedDataType: 'number',
  //     tileSize: { xs: '12' },
  //     optionArray: [
  //       {
  //         className: 'textWithDescription',
  //         optionLabel: 'Signature',
  //         optionLabelBadge: 'Recommended',
  //         optionDescription: `For those who don't have the time to write into each section. You can always add and update your information later.`,
  //         optionTimer: '5 min - Requires Paystub/Leave & Earnings Statement',
  //         optionValue: 1,
  //       },
  //       {
  //         className: 'textWithDescription',
  //         optionLabel: `Manual`,
  //         optionDescription: `This path allows you to input more information about your finances so your plan will be more accurate than the quick path once you're done!`,
  //         optionTimer: '11 min',
  //         optionValue: 2,
  //       },
  //       // {
  //       //   className: 'textWithDescription',
  //       //   optionLabel: 'Explore Deferred Retirement',
  //       //   optionLabelBadge: 'Urgent',
  //       //   optionLabelBadgeType: 'error',
  //       //   optionDescription: `Explore your options regarding your 'Deferred Retirement' offer. We will give you the info you need and provide our PARCO recommendation based on your exact situation.`,
  //       //   optionTimer: `2 min + time for any additional flows you'd like`,
  //       //   optionValue: 3,
  //       // },
  //       // {
  //       //   className: 'textWithDescription',
  //       //   optionLabel: 'Schedule Appointment',
  //       //   optionLabelBadge: 'Seminar Participants',
  //       //   optionDescription: `For those who just need to schedule an appointment.`,
  //       //   optionTimer: '1 min',
  //       //   optionValue: 3,
  //       // },
  //     ],
  //     handleNextOverride: async (intakeState, onboardingHooks) => {
  //       const { updateIntakeStateAtKey } = onboardingHooks
  //       updateIntakeStateAtKey({
  //         pickYourPath: 1,
  //       })
  //       return {
  //         intakeState: {
  //           ...intakeState,
  //           pickYourPath: 1,
  //         },
  //       }
  //     },
  //   },
  //   dependencies: [],
  // },
  //TEMPORARY REPLACEMENT FOR PICK YOUR PATH
  // {
  //   id: 'pickYourPath',
  //   type: 'Interstitial Screen',
  //   props: {
  //     inputType: 'displayOnly',
  //     subHeader: `These details will help us calculate your benefits and aid in planning your ideal retirement.`,
  //     label: 'Onboarding',
  //     options: null,
  //     header: `Let's Finish Your Account Setup!`,
  //     time: '9 mins on average',
  //     handleNextOverride: async (intakeState, onboardingHooks) => {
  //       const { updateIntakeStateAtKey } = onboardingHooks
  //       updateIntakeStateAtKey({
  //         pickYourPath: 1,
  //       })
  //       return {
  //         intakeState: {
  //           ...intakeState,
  //           pickYourPath: 1,
  //         },
  //       }
  //     },
  //   },
  //   dependencies: [],
  // },
  {
    id: 'workFromHome',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['buyoutFlow'],
    props: {
      preHeader: `At least up until recently`,
      header: 'Have you been working from home?',
      subHeader: 'Select one of the following:',
      id: 'workFromHome',
    },
    dependencies: [{ attribute: 'pickYourPath', value: 3 }],
  },
  {
    id: 'returnToOffice',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['buyoutFlow'],
    props: {
      preHeader: '',
      header: 'Do you want to return to the office?',
      subHeader: 'Select one of the following:',
      id: 'returnToOffice',
    },
    dependencies: [{ attribute: 'pickYourPath', value: 3 }],
  },
  {
    id: 'forkEvaluation',
    type: 'Question',
    component: OnboardingInformation,
    tags: ['buyoutFlow'],
    props: {
      preHeader: '',
      header: `Evaluating the "Deferred Resignation"`,
      subHeader: `Consider the Pros and Cons:`,
      additionalContent: <></>,
    },
    dependencies: [{ attribute: 'pickYourPath', value: 3 }],
  },
  {
    id: 'exploreYourOptions',
    type: 'Question',
    component: OnboardingMultiOptionTile,
    tags: ['buyoutFlow'],
    props: {
      id: 'forkSelection',
      preHeader: '',
      header: 'Which Way Are You Leaning?',
      subHeader: ``,
      helpText: '',
      expectedDataType: 'string',
      tileSize: { xs: '12' },
      optionArray: [
        {
          className: 'textWithDescription',
          optionLabel: 'Accept The Deferred Resignation Offer',
          optionLabelBadge: '',
          optionDescription: `Resign from your job, but get paid to not work for the next 8 months.`,
          optionAdditionalContent: <></>,
          optionTimer: '',
          optionTimerClass: '',
          optionValue: 'acceptDeferredResignation',
        },
        {
          className: 'textWithDescription',
          optionLabel: 'Return To Office',
          optionDescription: `Plan to head back to the office for work.`,
          optionTimer: '',
          optionTimerClass: '',
          optionValue: 'returnToOffice',
        },
        {
          className: 'textWithDescription',
          optionLabel: `I'm Still Not Sure`,
          optionDescription: `PARCO will help you evaluate your options.`,
          optionTimer: '',
          optionTimerClass: '',
          optionValue: 'notSure',
        },
      ],
    },
    dependencies: [{ attribute: 'pickYourPath', value: 3 }],
  },
  {
    id: 'exploreScenarios',
    type: 'Question',
    component: OnboardingMultiOptionTile,
    tags: ['buyoutFlow'],
    props: {
      id: 'forkSelectionScenarios',
      preHeader: '',
      header: 'Next Steps',
      subHeader: `Please select one of the following:`,
      helpText: '',
      expectedDataType: 'number',
      tileSize: { xs: '12' },
      optionArray: [
        {
          className: 'textWithDescription',
          optionLabel: 'Schedule an Appointment',
          optionDescription: `Choose when you'd like to speak with a PARCO financial advisor about any questions or concerns you have. We know a lot of Feds are worried ... we're here to help.`,
          optionAdditionalContent: '',
          optionTimer: '2 min',
          optionTimerClass: '',
          optionLink: '',
          optionValue: 1,
        },
        {
          className: 'textWithDescription',
          optionLabel: 'Unlock Your Dashboard - Complete Your Profile',
          optionDescription: `Finish filling out your profile for more insights.`,
          optionTimer: '5 - 12 min',
          optionLink: '/fork-flow?onboardingStep=interstitialScheduled',
          optionValue: 2,
        },
      ],
    },
    dependencies: [{ attribute: 'pickYourPath', value: 3 }],
  },
  {
    id: 'onboardingSchedule',
    component: OnboardingSchedule,
    type: 'Question',
    tags: ['buyoutFlow'],
    props: {},
    dependencies: [
      { attribute: 'pickYourPath', value: 3 },
      { attribute: 'forkSelectionScenarios', value: 1 },
    ],
  },
  // Retirement Goals (Leave)
  // {
  //   id: 'retirementGoals',
  //   type: 'Question',
  //   tags: ['onboarding'],
  //   component: OnboardingMultiSelectTile,
  //   props: {
  //     preHeader: '',
  //     header: 'How can we help you better prepare for retirement?',
  //     subHeader: 'Select all that apply:',
  //     helpText: '',
  //     tileSize: { xs: '6', sm: '4' },
  //     questionArray: [
  //       {
  //         id: 'goalAffordToRetire',
  //         optionLabel: 'Determine if I can afford to retire',
  //         optionIcon: <SavingsIcon />,
  //       },
  //       {
  //         id: 'goalMaximizeFederalBenefit',
  //         optionLabel: 'Maximize my federal benefits',
  //         optionIcon: <AssessmentIcon />,
  //       },
  //       {
  //         id: 'goalEarliestEligibility',
  //         optionLabel: 'Find my earliest retirement eligibility date',
  //         optionIcon: <EventAvailableIcon />,
  //       },
  //       {
  //         id: 'goalHelpFillingOutForms',
  //         optionLabel: 'Help with forms or retirement paperwork',
  //         optionIcon: <AssignmentIcon />,
  //       },
  //       {
  //         id: 'goalHelpInvestmentsTs',
  //         optionLabel: 'Get help with Investments/Retirement',
  //         optionIcon: <TrendingUpIcon />,
  //       },
  //       {
  //         id: 'goalCalculateRetirementNumbers',
  //         optionLabel: 'Help with Something Else',
  //         optionIcon: <HelpIcon />,
  //       },
  //     ],
  //   },
  //   dependencies: [
  //     { attribute: 'employmentStatus', value: 'employed' },
  //     { attribute: 'governmentEmployee', value: true },
  //   ],
  // },
  // {
  //   id: 'retiredGoals',
  //   type: 'Question',
  //   tags: ['onboarding'],
  //   component: OnboardingMultiSelectTile,
  //   props: {
  //     preHeader: '',
  //     header: 'How can we help you make the most of your retirement?',
  //     subHeader: 'Select all that apply:',
  //     helpText: '',
  //     tileSize: { xs: '6', sm: '4' },
  //     questionArray: [
  //       {
  //         id: 'goalLegacyPlanning',
  //         optionLabel: 'Make sure my legacy planning is set',
  //         optionIcon: <SavingsIcon />,
  //       },
  //       {
  //         id: 'goalMaximizeFederalBenefit',
  //         optionLabel: 'Help me take full advantage of my benefits',
  //         optionIcon: <AssessmentIcon />,
  //       },
  //       {
  //         id: 'goalHelpInvestmentsTs',
  //         optionLabel: 'Get help with Investments & TSP',
  //         optionIcon: <TrendingUpIcon />,
  //       },
  //       {
  //         id: 'goalPassMoneyOn',
  //         optionLabel: 'Pass on Money to my Kids',
  //         optionIcon: <FavoriteIcon />,
  //       },
  //       {
  //         id: 'goalSecureIncome',
  //         optionLabel: 'Secure my Income',
  //         optionIcon: <PaymentsIcon />,
  //       },
  //       {
  //         id: 'goalEstatePlanning',
  //         optionLabel: 'Estate Planning',
  //         optionIcon: <HomeIcon />,
  //       },
  //     ],
  //   },
  //   dependencies: [
  //     { attribute: 'employmentStatus', value: 'retired' },
  //     { attribute: 'governmentEmployee', value: true },
  //   ],
  // },
  {
    id: 'dateOfPlannedRetirementTileSelector',
    type: 'Question',
    tags: ['incomeStatement'],
    component: PlannedRetirementTileSelector,
    props: {
      label: 'Planned Retirement Date',
      handleNextOverride: async (intakeState, onboardingHooks) => {
        const { updateIntakeStateAtKey } = onboardingHooks
        updateIntakeStateAtKey({
          pickYourPath: 1,
        })
        return {
          intakeState: {
            ...intakeState,
            pickYourPath: 1,
          },
        }
      },
    },
    dependencies: [{ attribute: 'employmentStatus', value: 'employed' }],
  },
  {
    id: 'paystubOCR',
    type: 'Question',
    component: PaycheckOCR,
    props: {
      id: '',
      preHeader: '',
      header: 'Upload your paystub!',
      subHeader: `Using OCR technology, we can scan your paystub and automatically record most of your information. Saving our users an average of 7 minutes as opposed to manual data entry.`,
      helpText: '',
    },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'pickYourPath', value: 2 },
    ],
  },
  // {
  //   id: 'positionTitleWorking',
  //   type: 'Question',
  //   component: OnboardingMultiQuestion,
  //   tags: ['employmentDetails', 'onboarding'],
  //   props: {
  //     preHeader: '',
  //     header: 'What is your job title?',
  //     subHeader: 'Position',
  //     helpText: '',
  //     questionArray: [
  //       {
  //         id: 'positionTitle',
  //         label: 'Position/Title',
  //         helpText: `Certain job titles have certain leave rules. Certain positions have different leave rollover and sell back rules. Ex: if you are a nurse then your leave is higher`,

  //         placeholder: 'Position/Title',
  //         required: false,
  //         inputType: 'text',
  //       },
  //       {
  //         id: 'hiddenField',
  //         label: 'Hidden Field',
  //         helpText: '',
  //         placeholder: 'Hidden Field',
  //         required: false,
  //         inputType: 'text',
  //         hiddenField: true,
  //       },
  //     ],
  //   },
  //   dependencies: [{ attribute: 'employmentStatus', value: 'employed' }],
  // },

  // {
  //   id: 'positionTitleRetired',
  //   type: 'Question',
  //   component: OnboardingMultiQuestion,
  //   tags: ['employmentDetails', 'onboarding'],
  //   props: {
  //     preHeader: '',
  //     header: 'What was your job title?',
  //     subHeader: ' ',
  //     helpText: '',

  //     questionArray: [
  //       {
  //         id: 'positionTitle',
  //         label: 'Position/Title',
  //         helpText: `Certain job titles have certain leave rules. Certain positions have different leave rollover and sell back rules. Ex: if you are a nurse then your leave is higher`,

  //         placeholder: 'Position/Title',
  //         required: false,
  //         inputType: 'text',
  //       },
  //       {
  //         id: 'hiddenField',
  //         label: 'Hidden Field',
  //         helpText: '',
  //         placeholder: 'Hidden Field',
  //         required: false,
  //         inputType: 'text',
  //         hiddenField: true,
  //       },
  //     ],
  //   },
  //   dependencies: [{ attribute: 'employmentStatus', value: 'retired' }],
  // },

  //MILITARY FLOW
  {
    id: 'military',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['onboarding'],
    props: {
      header: 'Did you serve in the armed forces?',
      preHeader: '',
      subHeader: ' ',
      id: 'military',
    },
    dependencies: [],
  },
  {
    id: 'militaryBranch',
    type: 'Question',
    component: OnboardingMilitaryBranch,
    tags: ['onboarding'],
    props: {
      preHeader: 'Thank you for your service.',
      header: 'What branch of the military did you serve?',
      subHeader: 'Select one of the following:',
      helpText: 'If you were in the reserves this also qualifies',
      id: 'militaryBranch',
    },
    dependencies: [{ attribute: 'military', value: true }],
  },
  {
    id: 'militaryActiveDutyPension',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['onboarding'],
    props: {
      preHeader: '',
      header: 'Are you collecting an active duty pension?',
      subHeader: 'Select one of the following:',
      id: 'militaryActiveDutyPension',
    },
    dependencies: [{ attribute: 'military', value: true }],
  },

  {
    id: 'militaryBranchServiceDates',
    type: 'Question',
    component: OnboardingMilitaryServiceDates,
    tags: ['onboarding'],
    props: {
      preHeader: '',
      header: 'How long were you in the service?',
      subHeader:
        'If you’re not sure of exact dates, you can estimate the number of years and months you served instead.',
      helpText:
        'This helps us calculate how this service counts towards your pension',
    },
    dependencies: [
      { attribute: 'military', value: true },
      { attribute: 'militaryActiveDutyPension', value: true },

      // { attribute: 'militaryReserves', value: false },
    ],
  },

  //ASK ABOUT RESERVIST PENSION QUESTION

  // {
  //   id: 'militaryReservesPensionIncludesActiveDuty',
  //   type: 'Question',
  //   component: OnboardingYesNo,
  //   props: {
  //     preHeader: '',
  //     header: 'Will your reservist pension include any active duty service?',
  //     subHeader: 'Select one of the following:',
  //     id: 'militaryReservesPensionIncludesActiveDuty',
  //   },
  //   dependencies: [
  //     { attribute: 'military', value: true },
  //     { attribute: 'militaryActiveDutyPension', value: false },
  //   ],
  // },
  {
    id: 'militaryPaidDeposit',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['onboarding'],
    props: {
      preHeader: '',
      header:
        'Have you paid a deposit to your agency for this active duty time?',
      subHeader: 'Select one of the following:',
      id: 'militaryPaidDeposit',
    },
    dependencies: [
      { attribute: 'military', value: true },
      { attribute: 'governmentEmployee', value: true },
      { attribute: 'militaryActiveDutyPension', value: false },
    ],
  },

  {
    id: 'militaryBranchServiceDates',
    type: 'Question',
    component: OnboardingMilitaryServiceDates,
    tags: ['onboarding'],
    props: {
      preHeader: '',
      header: 'How long were you in the service?',
      subHeader: `If you're not sure of exact dates, you can estimate the number of years and months you served instead.`,
      helpText:
        'This helps us calculate how this service counts towards your pension',
    },
    dependencies: [
      { attribute: 'military', value: true },
      { attribute: 'militaryActiveDutyPension', value: false },

      // { attribute: 'militaryReserves', value: false },
    ],
  },

  {
    id: 'militaryReserves',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['onboarding'],
    props: {
      preHeader: '',
      header: 'Were you in the reserves?',
      subHeader: 'Select one of the following:',
      id: 'militaryReserves',
    },
    dependencies: [{ attribute: 'military', value: true }],
  },
  {
    id: 'militaryReserves',
    type: 'Question',
    component: OnboardingMilitaryReserves,
    tags: ['onboarding'],
    props: {
      preHeader: '',
      header: 'How much active duty time did you have in the reserves?',
      subHeader: `If you're not sure of exact dates, you can estimate the number of years and months you served instead.`,
      helpText:
        'This helps us calculate how this service counts towards your pension',
      id: 'militaryReserves',
    },
    dependencies: [
      { attribute: 'military', value: true },
      { attribute: 'militaryReserves', value: true },
    ],
  },

  {
    id: 'militaryReservesPension',
    type: 'Question',
    component: OnboardingYesNo,
    props: {
      preHeader: '',
      header: 'Are you already collecting a reservist pension?',
      subHeader: 'Select one of the following:',
      id: 'militaryReservesPension',
    },
    dependencies: [
      { attribute: 'military', value: true },
      { attribute: 'militaryReserves', value: true },
    ],
  },

  // END MILITARY FLOW

  //FAMILY FLOW
  {
    id: 'interstitialFamily',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `These details will help us calculate your benefits and aid in setting up beneficiaries.`,
      label: 'Family',
      options: null,
      header: `Let's Talk about Family!`,
      time: '2 Mins on average',
    },
    dependencies: [{ attribute: 'employmentStatus', value: 'employed' }],
  },
  {
    id: 'familyMaritalStatus',
    type: 'Question',
    component: OnboardingMaritalStatus,
    tags: ['onboarding'],
    props: {
      preHeader: '',
      header: 'What is your current marital status?',
      subHeader: 'Select one of the following:',
      helpText: '',
      id: 'familyMaritalStatus',
    },
    dependencies: [{ attribute: 'employmentStatus', value: 'employed' }],
  },
  {
    id: 'familySpouse',
    component: OnboardingSpouse, // change default to age not DOB
    tags: ['onboarding'],
    type: 'Question',
    props: {},
    dependencies: [{ attribute: 'familyMaritalStatus', value: 'married' }],
  },
  {
    id: 'familyDivorced',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['onboarding'],
    props: {
      preHeader: '',
      header: 'Have you ever been divorced?',
      subHeader: 'Select one of the following:',
      id: 'familyDivorced',
    },
    dependencies: [
      { attribute: 'familyMaritalStatus', value: 'divorced', inverse: true },
    ],
  },

  {
    id: 'familyOwedPension',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['onboarding'],
    props: {
      preHeader: '',
      header: 'Will your former spouse be owed any of your pension?',
      subHeader: 'Select one of the following:',
      id: 'familyDivorcedOwedPension',
    },
    dependencies: [
      {
        or: [
          { attribute: 'familyMaritalStatus', value: 'divorced' },
          { attribute: 'familyDivorced', value: true },
        ],
      },
      { attribute: 'governmentEmployee', value: true },
    ],
  },

  {
    id: 'familyOwedPensionTwo',
    type: 'Question',
    component: OnboardingDivorceDates,
    tags: ['onboarding'],
    props: {
      preHeader: '',
      header: 'Former Marriage Details',
      subHeader: ' ',
      helpText: '',
      id: 'familyDivorcedOwedPension',
    },
    dependencies: [
      { attribute: 'familyDivorcedOwedPension', value: true },
      { attribute: 'governmentEmployee', value: true },
    ],
  },

  {
    id: 'familyChildren',
    type: 'Question',
    component: OnboardingFamilyDependents,
    tags: [],
    props: {
      preHeader: '',
      header: `Let's talk about the rest of your family!`,
      subHeader: ' ',
      helpText: '',
    },
    dependencies: [{ attribute: 'employmentStatus', value: 'employed' }],
  },

  //PAY STUB FLOW
  {
    id: 'interstitialGrabYourPaystub',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `Now we are going to take a look at your pay stub. Grab your most recent and let's take a look!`,
      label: 'Pay Stub Details',
      options: null,
      header: 'Pay Stub Details',
      time: '2 Mins on average',
    },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'agency', value: 'u.s._postal_service_(usps)' },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  {
    id: 'interstitialGrabYourPaystub',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `Now we are going to take a look at your pay stub. Grab your most recent and let's take a look!`,
      label: 'Pay Stub Details',
      options: null,
      header: 'Pay Stub Details',
      time: '2 Mins on average',
    },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: false },
    ],
  },
  //swap for non postal
  {
    id: 'interstitialGrabYourPaystub',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `Now we are going to take a look at your leave and earnings. Grab your most recent statement and let's take a look!`,
      label: 'Leave & Earnings Details',
      options: null,
      header: 'Leave & Earnings Details',
      time: '2 Mins on average',
    },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      {
        attribute: 'agency',
        value: 'u.s._postal_service_(usps)',
        inverse: true,
      },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  //Employment
  {
    id: 'baseSalary',
    component: OnboardingPaystub,
    tags: ['incomeStatement', 'payStubDetails', 'onboarding'],
    props: {},
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'pickYourPath', value: 1 },
    ],
  },

  //Leave Balances
  {
    id: 'currentLeaveBalance',
    component: OnboardingLeave,
    tags: ['incomeStatement', 'payStubDetails', 'onboarding'],
    props: {},
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },

  //TSP Interstitial

  {
    id: '401kOnboarding',
    component: OnboardingMultiOptionTile,
    tags: ['onboarding', '401k'],
    props: {
      id: '401kOnboarding',
      preHeader: '',
      header: 'Does your company offer a 401k?',
      subHeader: 'Select one of the following:',
      helpText: '',
      expectedDataType: 'string',
      tileSize: { xs: '4' },
      optionArray: [
        {
          optionLabel: 'Yes, with a matching contribution',
          optionValue: 'yesWithMatchingContribution',
        },
        {
          optionLabel: 'Yes, without a matching contribution',
          optionValue: 'yesWithoutMatchingContribution',
        },
        {
          optionLabel: 'No',
          optionValue: 'no',
        },
      ],
    },
    dependencies: [{ attribute: 'governmentEmployee', value: false }],
  },
  {
    id: '401ktypesOfRetirementAccount',
    type: 'Question',
    tags: ['onboarding', '401k'],
    component: OnboardingMultiSelectTile,
    props: {
      preHeader: '',
      header: 'What types of retirement accounts do you have?',
      subHeader: 'Select all that apply:',
      helpText: '',
      tileSize: { xs: '6', sm: '4' },
      questionArray: [
        {
          id: 'traditional',
          optionLabel: 'Traditional',
        },
        {
          id: 'roth',
          optionLabel: 'Roth',
        },
      ],
    },
    dependencies: [
      { attribute: 'governmentEmployee', value: false },
      {
        or: [
          { attribute: '401kOnboarding', value: 'yesWithMatchingContribution' },
          {
            attribute: '401kOnboarding',
            value: 'yesWithoutMatchingContribution',
          },
        ],
      },
    ],
  },
  {
    id: '401kDetails',
    component: Onboarding401kDetails,
    tags: ['onboarding', '401k'],
    props: {
      helpText: 'This helps us calculate your retirement benefits',
      handleNextOverride: async (intakeState, onboardingHooks) => {
        const {
          financesClient: { createOrUpdateAccount, getAccounts },
        } = onboardingHooks

        const traditionalBalance = Number(intakeState?.traditionalBalance || 0)
        const rothBalance = Number(intakeState?.rothBalance || 0)

        if (!Number.isNaN(traditionalBalance) && traditionalBalance > 0) {
          const accounts = await getAccounts()
          console.log('accounts in 401kDetails', accounts)

          const existingTraditional = accounts.find(
            (account) =>
              account.subTypeClassification === '401k-traditional' &&
              account.type === 'asset'
          )

          if (existingTraditional) {
            await createOrUpdateAccount({
              name: 'Traditional 401k',
              type: 'asset',
              subType: 'otherassets',
              amount: traditionalBalance,
              subTypeClassification: '401k-traditional',
              typeSubTypeUuid: existingTraditional.typeSubTypeUuid,
            })
          } else {
            await createOrUpdateAccount({
              name: 'Traditional 401k',
              type: 'asset',
              subType: 'otherassets',
              amount: traditionalBalance,
              subTypeClassification: '401k-traditional',
            })
          }
        }

        if (!Number.isNaN(rothBalance) && rothBalance > 0) {
          const accounts = await getAccounts()
          console.log('accounts in 401kDetails', accounts)

          const existingRoth = accounts.find(
            (account) =>
              account.subTypeClassification === '401k-roth' &&
              account.type === 'asset'
          )

          if (existingRoth) {
            await createOrUpdateAccount({
              name: 'Roth 401k',
              type: 'asset',
              subType: 'investment',
              amount: rothBalance,
              subTypeClassification: '401k-roth',
              typeSubTypeUuid: existingRoth.typeSubTypeUuid,
            })
          } else {
            await createOrUpdateAccount({
              name: 'Roth 401k',
              type: 'asset',
              subType: 'investment',
              amount: rothBalance,
              subTypeClassification: '401k-roth',
            })
          }
        }

        return { intakeState }
      },
    },
    dependencies: [
      { attribute: 'governmentEmployee', value: false },
      {
        or: [
          { attribute: '401kOnboarding', value: 'yesWithMatchingContribution' },
          {
            attribute: '401kOnboarding',
            value: 'yesWithoutMatchingContribution',
          },
        ],
      },
    ],
  },
  // TSP Information

  {
    id: 'tspInformation',
    type: 'Question',
    tags: ['onboarding'],
    component: OnboardingMultiSelectTile,
    props: {
      preHeader: '',
      header:
        'Let’s talk about your TSP! Which of the following do you contribute to?',
      subHeader: 'Select all that apply:',
      helpText: '',
      tileSize: { xs: '6', sm: '4' },
      questionArray: [
        {
          id: 'tsp',
          optionLabel: 'TSP Traditional',
        },
        {
          id: 'tspRoth',
          optionLabel: 'TSP Roth',
        },
        {
          id: '',
          optionLabel: 'Neither',
        },
      ],
    },
    dependencies: [{ attribute: 'governmentEmployee', value: true }],
  },

  {
    id: 'tspOnboarding',
    component: OnboardingTSP,
    tags: ['incomeStatement', 'tsp', 'deductionDetails', 'onboarding'],
    props: {},
    dependencies: [
      { attribute: 'governmentEmployee', value: true },
      {
        or: [
          { attribute: 'tsp', value: true },
          { attribute: 'tspRoth', value: true },
        ],
      },
    ],
  },

  {
    id: 'tspLoansOnboarding',
    component: OnboardingYesNo,
    tags: ['incomeStatement', 'deductionDetails', 'onboarding'],
    props: {
      preHeader: '',
      header: 'Do you have any TSP Loans?',
      subHeader: 'Select one of the following:',
      id: 'tspLoans',
    },
    dependencies: [
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },

      {
        or: [
          { attribute: 'tsp', value: true },
          { attribute: 'tspRoth', value: true },
        ],
      },
    ],
  },
  {
    id: 'tspLoansValue',
    type: 'Question',
    component: TSPLoan,
    tags: ['incomeStatement', 'deductionDetails', 'onboarding'],
    dependencies: [
      { attribute: 'tspLoans', value: true },
      {
        or: [
          { attribute: 'tsp', value: true },
          { attribute: 'tspRoth', value: true },
        ],
      },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  {
    id: 'healthInsuranceTileSelector',
    type: 'Question',
    component: HealthcareTileSelector,
    tags: ['incomeStatement', 'deductionDetails', 'onboarding'],
    props: { label: 'Healthcare Selection' },
    dependencies: [
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  {
    id: 'deductionsTypeSelection',
    type: 'Question',
    component: WizardStep,
    tags: ['incomeStatement', 'deductionDetails', 'onboarding'],
    props: {
      inputType: 'deductionTypeSelection',
      header: 'Staying on your paystub, what deductions do you have?',
      subHeader: 'Please select all that apply:',
      preHeader: '',
      handleNextOverride: async (
        _intakeState,
        onboardingHooks,
        nonUserState,
        setActiveStep,
        activeStep
      ) => {
        if (
          Object.keys(nonUserState).length === 0 ||
          (Object.keys(nonUserState).length === 1 &&
            Array.isArray(nonUserState.deductionTypesToInput) &&
            nonUserState.deductionTypesToInput.length === 0)
        ) {
          setActiveStep(activeStep + 2)
          return false
        }
      },
    },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  {
    id: 'deductions',
    type: 'Question',
    component: WizardStep,
    tags: ['incomeStatement', 'deductionDetails', 'onboarding'],
    props: {
      inputType: 'deduction',
      header: 'How much are these deductions for?',
      subHeader: 'Enter the values for the deductions that you selected:',
      preHeader: '',
      handleNextOverride: async (
        _intakeState,
        onboardingHooks,
        nonUserState
      ) => {
        const {
          financesClient: { createAccounts },
          setNonUserState,
        } = onboardingHooks
        if (nonUserState.deductionsToSubmit != null) {
          await createAccounts(nonUserState.deductionsToSubmit)
        }
        setNonUserState((prevState) => ({
          ...prevState,
          deductionTypesToInput: [],
          deductionsToSubmit: [],
        }))
        return { intakeState: _intakeState, nonUserState }
      },
    },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  //ADD IN DEDUCTIONS REVIEW
  {
    id: 'deductionsReview',
    type: 'Question',
    component: WizardStep,
    tags: ['incomeStatement', 'deductionDetails', 'onboarding'],
    props: {
      inputType: 'deductionsReview',
      header: `Let's double-check!`,
      subHeader: 'Please edit or add any deductions you might have:',
      preHeader: '',
    },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },

  {
    id: 'interstitialPrivateLifeInsurance',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `This helps us optimize your legacy and life insurance plans.`,
      label: 'Private Life Insurance',
      options: null,
      header: 'Let’s talk about Life Insurance!',
      time: '2 Mins on average',
    },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: false },
    ],
  },

  // FEGLI FLOW
  {
    id: 'interstitialFEGLI',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      image: false,
      subHeader: `This section unlocks your Life Insurance Summary table, so you can see all your coverage in one place.`,
      label: 'FEGLI',
      extraContent: (
        <div style={{ marginTop: '16px' }}>
          <LifeInsuranceSummary isDemo={true} />
        </div>
      ),
      options: null,
      header: 'Let’s talk about FEGLI and Life Insurance!',
      time: '2 Mins on average',
    },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  {
    id: 'fegli',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['fegli', 'onboarding'],
    props: {
      preHeader: '',
      header: 'Are you currently enrolled in FEGLI coverage?',
      subHeader: ' ',
      id: 'fegli',
      handleNextOverride: async (intakeState, onboardingHooks) => {
        const { updateIntakeStateAtKey } = onboardingHooks
        const fegliExtra = intakeState?.fegli ? false : true
        const fegliReduction = intakeState?.fegli ? '75%' : ''
        updateIntakeStateAtKey({
          fegliExtraABL: fegliExtra,
          fegliExtraBLReduction: fegliReduction,
        })
        return {
          intakeState: {
            ...intakeState,
            fegliExtraABL: fegliExtra,
            fegliExtraBLReduction: fegliReduction,
          },
        }
      },
    },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  {
    id: 'fegliCoverage',
    type: 'Question',
    component: OnboardingMultiSelectTile,
    tags: ['fegli', 'onboarding'],
    props: {
      preHeader: '',
      header: 'Do you have any optional FEGLI coverage?',
      subHeader: 'Select all that apply:',
      helpText: '',
      tileSize: { xs: '4', md: '2', lg: '4' },
      questionArray: [
        {
          id: 'fegli',
          optionLabel: 'Basic Life',
          className: 'no-click',
        },
        {
          id: 'fegliOptionA',
          optionLabel: 'Option A',
        },
        {
          id: 'fegliOptionB',
          optionLabel: 'Option B',
        },
        {
          id: 'fegliOptionC',
          optionLabel: 'Option C',
        },
        {
          id: 'fegliNone',
          optionLabel: `I don't have any`,
        },
        {
          id: 'fegliNotSure',
          optionLabel: `I don't know`,
        },
      ],
    },
    dependencies: [
      { attribute: 'fegli', value: true },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  {
    id: 'fegliOptionBMultiples',
    type: 'Question',
    component: OnboardingMultiOptionTile,
    tags: ['fegli', 'onboarding'],
    props: {
      id: 'fegliOptionBMultiples',
      preHeader: '',
      header: 'How many multiples of Option B do you have?',
      subHeader: 'Select one of the following:',
      helpText: '',
      expectedDataType: 'number',
      tileSize: { xs: '4', md: '2', lg: '4', xxl: '2' },
      optionArray: [
        {
          optionLabel: '1',
          optionValue: 1,
        },
        {
          optionLabel: '2',
          optionValue: 2,
        },
        {
          optionLabel: '3',
          optionValue: 3,
        },
        {
          optionLabel: '4',
          optionValue: 4,
        },
        {
          optionLabel: '5',
          optionValue: 5,
        },
        {
          optionLabel: 'Unsure',
          optionValue: 0,
        },
      ],
    },
    dependencies: [
      { attribute: 'fegli', value: true },

      { attribute: 'fegliOptionB', value: true },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  {
    id: 'fegliOptionCMultiples',
    type: 'Question',
    component: OnboardingMultiOptionTile,
    tags: ['fegli', 'onboarding'],
    props: {
      id: 'fegliOptionCMultiples',
      preHeader: '',
      header: 'How many multiples of Option C do you have?',
      subHeader: 'Select one of the following:',
      helpText: '',
      expectedDataType: 'number',
      tileSize: { xs: '4', md: '2', lg: '4', xxl: '2' },
      optionArray: [
        {
          optionLabel: '1',
          optionValue: 1,
        },
        {
          optionLabel: '2',
          optionValue: 2,
        },
        {
          optionLabel: '3',
          optionValue: 3,
        },
        {
          optionLabel: '4',
          optionValue: 4,
        },
        {
          optionLabel: '5',
          optionValue: 5,
        },
        {
          optionLabel: 'Unsure',
          optionValue: 0,
        },
      ],
    },
    dependencies: [
      { attribute: 'fegli', value: true },

      { attribute: 'fegliOptionC', value: true },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  {
    id: 'lifeInsuranceOther',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['fegli', 'onboarding'],
    props: {
      preHeader: '',
      header: 'Do you have any private life insurance?',
      subHeader: ' ',
      id: 'lifeInsuranceOther',
    },
    dependencies: [{ attribute: 'pickYourPath', value: 1 }],
  },
  {
    id: 'lifeInsuranceOtherPrivateLifeInsurance',
    type: 'Question',
    component: OnboardingLifeInsurance,
    tags: ['fegli', 'onboarding'],
    props: {
      preHeader: '',
      header: 'Tell us about the Private Life Insureance you have:',
      subHeader: ' ',
      id: 'privateLifeInsurance',
    },
    dependencies: [{ attribute: 'lifeInsuranceOther', value: true }],
  },

  {
    id: 'FEGLIUnlock',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      image: false,
      subHeader: `Check it out on your Life Insurance page once you complete onboarding, to see all your Life Insurance coverage, and costs.`,
      label: 'FEGLI',
      extraContent: (
        <>
          <div>
            <LifeInsuranceSummary isDemo={false} isUnlocked={true} />
          </div>
        </>
      ),
      options: null,
      header: 'Life Insurance Summary Unlocked!',
    },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      { attribute: 'pickYourPath', value: 1 },
    ],
  },

  //TODO: MAKE SURVIVOR INTRO

  {
    id: 'interstitialSurvivor',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `It’s helpful to know about Survivor Benefit so we can be sure to include it as a pension deduction in retirement.`,
      label: 'Survivor Benefit',
      options: null,
      header: "Let's talk about Survivor Benefit",
      time: '2 Mins on average',
    },
    dependencies: [
      { attribute: 'employmentStatus', value: 'employed' },
      {
        or: [
          { attribute: 'familyMaritalStatus', value: 'married' },
          { attribute: 'familyDivorcedOwedPension', value: true },
        ],
      },
      { attribute: 'pickYourPath', value: 1 },
      { attribute: 'governmentEmployee', value: true },
    ],
  },

  {
    id: 'survivorBenefitElection',
    type: 'Question',
    component: OnboardingMultiOptionTile,
    tags: ['incomeStatement', 'onboarding'],
    props: {
      id: 'survivorBenefitElection',
      preHeader: '',
      header:
        'How much of a survivor benefit do you want to elect on your pension?',
      subHeader: ' ',
      helpText: '',
      expectedDataType: 'string',
      tileSize: { xs: '6', xl: '3' },
      optionArray: [
        {
          optionLabel: 'Full',
          optionValue: 'full',
        },
        {
          optionLabel: 'Partial',
          optionValue: 'partial',
        },
        {
          optionLabel: 'None',
          optionValue: 'none',
        },
        {
          optionLabel: `I'm not sure`,
          optionValue: 'notsure',
        },
      ],
    },
    dependencies: [
      { attribute: 'familyMaritalStatus', value: 'married' },
      { attribute: 'governmentEmployee', value: true },
    ],
  },
  {
    id: 'survivorBenefitElectionSpouse',
    type: 'Question',
    component: OnboardingMultiOptionTile,
    tags: ['incomeStatement', 'onboarding'],
    props: {
      id: 'survivorBenefitElectionSpouse',
      preHeader: '',
      header:
        'Are you court ordered to give your former spouse some of your survivor benefit?',
      subHeader: ' ',
      helpText: '',
      expectedDataType: 'string',
      tileSize: { xs: '6', xl: '3' },
      optionArray: [
        {
          optionLabel: 'Yes, in full',
          optionValue: 'full',
        },
        {
          optionLabel: 'Yes, partially',
          optionValue: 'partial',
        },
        {
          optionLabel: 'No',
          optionValue: 'no',
        },
        {
          optionLabel: `I'm not sure`,
          optionValue: 'notsure',
        },
      ],
    },
    dependencies: [
      { attribute: 'familyDivorcedOwedPension', value: true },
      { attribute: 'governmentEmployee', value: true },
    ],
  },

  //NET WORTH FLOW

  {
    id: 'interstitialNetWorth',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `This section unlocks your Net Worth and Balance Sheet on your dashboard. We also have the option to link your accounts if you’d prefer automatic balance updates.`,
      label: 'Net Worth',
      options: null,
      image: false,
      extraContent: (
        <>
          <Card
            header={
              <Banner
                demoMode={true}
                color={'white'}
                type={'header'}
                // actionText="ADD / LINK ACCOUNT"
                title="MY NET WORTH"
                description={'$XXk'}
                subText="up"
                content={<NetWorthGraph demoMode={true} />}
              />
            }
          >
            <NetWorthTable demoMode={true} />
          </Card>
        </>
      ),
      header: `Let’s calculate your Net Worth!`,
      time: '4 Mins on average',
    },
    // dependencies: [{ attribute: 'employmentStatus', value: 'employed' }],
  },

  {
    id: 'netWorthAssetReview',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `You’ve already provided your retirement info so we’ve added it below, continue to add your other assets so you can see them all in one place.`,
      label: 'Net Worth',
      options: null,
      image: false,
      extraContent: (
        <>
          <AssetReview demoMode={false} />
        </>
      ),
      header: `Let’s review your assets!`,
    },
    // dependencies: [{ attribute: 'employmentStatus', value: 'employed' }],
  },

  {
    id: 'netWorthLiabilityReview',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `Continue to liabilities until it all looks right.`,
      label: 'Net Worth',
      options: null,
      image: false,
      extraContent: (
        <>
          <LiabilityReview demoMode={false} />
        </>
      ),
      header: `Add all of your Liabilities or Debts`,
    },
    // dependencies: [{ attribute: 'employmentStatus', value: 'employed' }],
  },

  {
    id: 'netWorthUnlocked',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `You can now see your Net Worth and all your accounts within this tile on your dashboard.`,
      label: 'Net Worth',
      options: null,
      image: false,
      extraContent: (
        <>
          <NetWorthUnlock />
        </>
      ),
      header: `Net Worth tile unlocked!`,
    },
    // dependencies: [{ attribute: 'employmentStatus', value: 'employed' }],
  },

  // TSP FLOW
  {
    id: 'interstitialTSP',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `Completing this section unlocks your TSP Breakdown, so you can see all your TSP info in one place.`,
      label: 'TSP',
      options: null,
      image: false,
      extraContent: (
        <>
          <div style={{ filter: 'grayscale(100)' }}>
            <NewTsp isDemo={true} />
          </div>
        </>
      ),
      header: `Unlock your TSP Breakdown and more!`,
      time: '4 Mins on average',
    },
    dependencies: [{ attribute: 'governmentEmployee', value: true }],
  },

  {
    id: 'TSPPage2',
    type: 'Custom',
    component: TSPUnlock,
    props: {
      page: 2,
      handleNextOverride: (
        intakeState,
        onboardingHooks,
        nonUserState,
        setActiveStep,
        activeStep
      ) => {
        const allocation = intakeState?.tspDetails || {}

        const hasSpecificLFunds = Object.keys(allocation).some(
          (key) =>
            key.startsWith('tspL') &&
            key !== 'tspLFund' &&
            allocation[key]?.selected
        )

        if (allocation.tspLFund?.selected) {
          if (hasSpecificLFunds) {
            setActiveStep(activeStep + 1)
          } else {
            setActiveStep(activeStep + 1)
          }
        } else {
          setActiveStep(activeStep + 2)
        }

        return false
      },
    },
    dependencies: [{ attribute: 'governmentEmployee', value: true }],
  },
  {
    id: 'TSPPage3',
    type: 'Custom',
    component: TSPUnlock,
    props: {
      page: 3,
    },
    dependencies: [{ attribute: 'governmentEmployee', value: true }],
  },
  {
    id: 'TSPPage4',
    type: 'Custom',
    component: TSPUnlock,
    props: {
      page: 4,
    },
    dependencies: [{ attribute: 'governmentEmployee', value: true }],
  },

  {
    id: 'UnlockedTSP',
    type: 'Custom',
    component: TSPUnlock,
    props: {
      page: 6,
    },
    dependencies: [{ attribute: 'governmentEmployee', value: true }],
  },

  //OUTRO FINAL STEPS
  {
    id: 'interstitialFinalSteps',
    type: 'Interstitial Screen',
    props: {
      time: '2 Mins on average',

      inputType: 'displayOnly',
      subHeader: `You're almost there!`,
      label: 'FinalSteps',
      options: null,
      header: `Final Questions!`,
    },
    dependencies: [],
  },
  {
    id: 'hasWill',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['onboarding'],
    props: {
      preHeader: '',
      header: 'Do you have a Will?',
      subHeader: ' ',
      id: 'hasWill',
    },
    dependencies: [],
  },
  {
    id: 'hasTrust',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['onboarding'],
    props: {
      preHeader: '',
      header: 'Do you have a Trust?',
      subHeader: ' ',
      id: 'hasTrust',
    },
    dependencies: [],
  },

  //SOCIAL SECURITY
  {
    id: 'estimatedSocialSecurityalreadyCollectingSocialSecurity',
    type: 'Question',
    component: OnboardingYesNo,
    tags: ['incomeStatement', 'onboarding'],
    props: {
      preHeader: '',
      header: `Are you already collecting Social Security?`,
      subHeader: 'Select one of the following:',
      id: 'alreadyCollectingSocialSecurity',
      handleNextOverride: async (intakeState, onboardingHooks) => {
        const { updateIntakeStateAtKey } = onboardingHooks

        // Determine the new value according to your logic
        const calculatedSS = intakeState?.alreadyCollectingSocialSecurity
          ? 2400
          : intakeState?.retirementSystem === 'csrs'
          ? 0
          : 2400

        // Only update if undefined or 0
        const shouldUpdate =
          intakeState?.estimatedSocialSecurity === undefined ||
          intakeState?.estimatedSocialSecurity === 0

        if (shouldUpdate) {
          updateIntakeStateAtKey({
            estimatedSocialSecurity: calculatedSS,
            ageToBeginCollectingSS: 62,
            ageToBeginCollectingSSMonths: 0,
          })
        }

        return {
          intakeState: {
            ...intakeState,
            estimatedSocialSecurity: shouldUpdate
              ? calculatedSS
              : intakeState.estimatedSocialSecurity,
            ageToBeginCollectingSS: intakeState.ageToBeginCollectingSS ?? 62,
            ageToBeginCollectingSSMonths:
              intakeState.ageToBeginCollectingSSMonths ?? 0,
          },
        }
      },
    },
    dependencies: [
      {
        attribute: 'dateOfBirth',
        value: (dateOfBirth) => {
          if (!dateOfBirth) return false
          const today = new Date()
          const birthDate = new Date(dateOfBirth)
          let age = today.getFullYear() - birthDate.getFullYear()
          const monthDiff = today.getMonth() - birthDate.getMonth()

          // Adjust age if birthday hasn't occurred yet this year
          if (
            monthDiff < 0 ||
            (monthDiff === 0 && today.getDate() < birthDate.getDate())
          ) {
            age--
          }
          return age >= 62
        },
      },
    ],
  },
  {
    id: 'estimatedSocialSecurity',
    type: 'Question',
    component: OnboardingMultiQuestion,
    tags: ['incomeStatement', 'onboarding'],
    props: {
      preHeader: '',
      header: `What is your Social Security Benefit at Full Retirement Age?`,
      subHeader: (
        <>
          If you do not know your actual amount (found at{' '}
          <Link
            sx={{
              color: '#2370ED',
              textDecoration: 'underline',
              fontWeight: 500,
            }}
            href="https://www.ssa.gov/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.ssa.gov/
          </Link>
          ) we will use a conservative estimate of $2,400
        </>
      ),
      helpText:
        'Your full retirement age is calculated based on your birth date and when you started working. This is necessary for us calculate your Social Security benefit.',
      questionArray: [
        {
          id: 'estimatedSocialSecurity',
          label: 'Benefit Amount',
          helpText:
            'You can find more information and your actual amount by logging into your account at https://www.ssa.gov/',
          placeholder: '$2,400.00',
          defaultValue: 2400,
          required: false,
          inputType: 'currencyFloat',
        },
        {
          id: 'hiddenField',
          label: 'Hidden Field',
          helpText: '',
          placeholder: 'Hidden Field',
          required: false,
          inputType: 'text',
          hiddenField: true,
        },
      ],
      // Why is this default not working?
      handleNextOverride: async (intakeState, onboardingHooks) => {
        const { updateIntakeStateAtKey } = onboardingHooks

        const shouldUpdate =
          intakeState?.estimatedSocialSecurity === undefined ||
          intakeState?.estimatedSocialSecurity === 0 ||
          intakeState?.estimatedSocialSecurity === ''

        if (shouldUpdate) {
          updateIntakeStateAtKey({
            estimatedSocialSecurity:
              intakeState?.retirementSystem === 'csrs' ? 0 : 2400,
          })
        }

        return {
          intakeState: {
            ...intakeState,
            estimatedSocialSecurity: shouldUpdate
              ? intakeState?.retirementSystem === 'csrs'
                ? 0
                : 2400
              : intakeState.estimatedSocialSecurity,
          },
        }
      },
    },
    dependencies: [
      {
        or: [
          { attribute: 'alreadyCollectingSocialSecurity', value: false },
          { attribute: 'alreadyCollectingSocialSecurity', value: undefined },
        ],
      },
    ],
  },
  {
    id: 'estimatedSocialSecurityAlreadyCollecting',
    type: 'Question',
    component: OnboardingMultiQuestion,
    tags: ['incomeStatement', 'onboarding'],
    props: {
      preHeader: '',
      header: `What is your Monthly Social Security benefit?`,
      subHeader: ' ',
      helpText: '',
      questionArray: [
        {
          id: 'estimatedSocialSecurity',
          label: 'Benefit Amount',
          helpText: 'You can find more information at https://www.ssa.gov/',
          placeholder: '$2,400.00',
          required: false,
          inputType: 'currencyFloat',
        },
        {
          id: 'hiddenField',
          label: 'Hidden Field',
          helpText: '',
          placeholder: 'Hidden Field',
          required: false,
          inputType: 'text',
          hiddenField: true,
        },
      ],
      handleNextOverride: async (intakeState, onboardingHooks) => {
        const { updateIntakeStateAtKey } = onboardingHooks

        const shouldUpdate =
          intakeState?.estimatedSocialSecurity === undefined ||
          intakeState?.estimatedSocialSecurity === 0 ||
          intakeState?.estimatedSocialSecurity === ''

        if (shouldUpdate) {
          updateIntakeStateAtKey({
            estimatedSocialSecurity:
              intakeState?.retirementSystem === 'csrs' ? 0 : 2400,
          })
        }

        return {
          intakeState: {
            ...intakeState,
            estimatedSocialSecurity: shouldUpdate
              ? intakeState?.retirementSystem === 'csrs'
                ? 0
                : 2400
              : intakeState.estimatedSocialSecurity,
          },
        }
      },
    },
    dependencies: [
      { attribute: 'alreadyCollectingSocialSecurity', value: true },
    ],
  },
  // {
  //   id: 'unionAffiliation',
  //   type: 'Question',
  //   props: {
  //     inputType: 'select',
  //     header: 'Tell us about your Union Affiliation',
  //     subHeader:
  //       "We noticed you're paying union dues, which union are you a member of?",
  //     label: 'Union Affiliation',
  //     id: 'unionAffiliation',
  //     placeholder: 'Select a union...',
  //     options: selectData.unionAffiliation,
  //     dependencies: [
  //       {
  //         attribute: 'unionAffiliation',
  //         value: 'a',
  //       },
  //     ],
  //   },
  // },
  // {
  //   id: 'unionLocal',
  //   type: 'Question',
  //   props: {
  //     inputType: 'select',
  //     subHeader: "What's your local number or the city you're a member of?",
  //     label: 'Union Local',
  //     id: 'unionLocal',
  //     placeholder: 'Select an option...',
  //     options: selectData.unionLocal,
  //     header: 'Tell us about your Union Affiliation',
  //     dependencies: [
  //       {
  //         attribute: 'unionLocal',
  //         value: 'a',
  //       },
  //     ],
  //   },
  // },
  // {
  //   id: 'taxRate',
  //   type: 'Question',
  //   props: {
  //     inputType: 'select',
  //     id: 'taxRate',
  //     subHeader:
  //       "We estimated your all-in tax rate to be about 20%. If you think it's going to be something else, please select the right amount below.",
  //     label: 'Tax Rate',
  //     placeholder: 'Select a tax rate...',
  //     options: selectData.taxRate,
  //     header: 'Tell us about your Taxes',
  //     dependencies: [
  //       {
  //         attribute: '',
  //       },
  //     ],
  //   },
  // },
  //lifestyle Goal
  {
    id: 'retirementLifestyleGoal',
    type: 'Question',
    component: LifestyleGoal,
    tags: ['onboarding'],
    dependencies: [],
  },
  //Onboarding Complete

  {
    id: 'RetirementGapUnlock',
    type: 'Interstitial Screen',
    props: {
      inputType: 'displayOnly',
      subHeader: `Your Retirement Income Statement and Gap are critical to understanding the lifestyle you’re setting yourself up for in retirement.`,
      label: 'Net Worth',
      options: null,
      image: false,
      extraContent: (
        <>
          <RetirementGapUnlock />
        </>
      ),

      header: `‘Retirement Income Gap’ tile unlocked!`,
    },
  },
  {
    id: 'onboardingComplete',
    component: CompletedOnboarding,
    tags: [],
    props: {
      header: `Onboarding Complete!`,
      subHeader: 'A member of the PARCO team will be in touch soon!',
    },
    dependencies: [],
  },
]
